import {Modal, Flex, Button, Group} from '@mantine/core';
import React, {useState} from 'react';

import {
  ChemicalStructureDrawer,
  ChemicalStructureDrawerMode,
  ChemicalStructureDrawerValue,
} from 'chemistry/marvinjs-wrappers/ChemicalStructureDrawer';
import {MarvinChemicalFormat} from 'chemistry/marvinjs-wrappers/MarvinJSConstants';
import ModalFooter from 'ui-library/modals/ModalFooter';

interface ReactionSketcherModalProps {
  onClose: () => void;
  onSubmit: (newMarvinStructure: string) => Promise<void>;
  initialMarvinStructure: ChemicalStructureDrawerValue;
}

export default function ReactionSketcherModal({
  onClose,
  onSubmit,
  initialMarvinStructure,
}: ReactionSketcherModalProps): JSX.Element {
  const [structureContent, setStructureContent] =
    useState<ChemicalStructureDrawerValue>(initialMarvinStructure);
  const [hasReactionContents, setHasReactionContents] = useState(false);

  return (
    <Modal
      title="Reaction Sketcher"
      opened={true}
      onClose={onClose}
      size="xl"
      styles={{
        content: {
          height: '90vh',
          display: 'flex',
          flexDirection: 'column',
        },
        body: {
          flex: 1,
        },
      }}
    >
      <Flex direction="column" h="100%">
        <ChemicalStructureDrawer
          mode={ChemicalStructureDrawerMode.REACTION}
          onMoleculeChange={setStructureContent}
          setHasReactionContents={setHasReactionContents}
          initialValue={initialMarvinStructure}
          inputFormat={MarvinChemicalFormat.MRV}
          outputFormat={MarvinChemicalFormat.MRV}
        />
        <ModalFooter>
          <Group position="right">
            <Button type="button" onClick={onClose} variant="secondary">
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!hasReactionContents}
              onClick={() => {
                onSubmit(structureContent!);
              }}
            >
              Save
            </Button>
          </Group>
        </ModalFooter>
      </Flex>
    </Modal>
  );
}
